var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWrapper',{ref:"pageEl",attrs:{"title":_vm.title}},[_c('div',{staticClass:"header"},[_c('sc-button',{attrs:{"route":_vm.createButton.route,"variant":"primary"}},[_vm._v(_vm._s(_vm.createButton.title))])],1),_vm._v(" "),_c('insurance-list',{attrs:{"data":_vm.insuranceList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }